import { registerLocaleData } from '@angular/common';
import { cs, de, enGB, es, fr, it, nlBE } from 'date-fns/locale';
import {
  LanguageCode,
  LanguageCodes,
} from '@app-shared/enums/language-codes.enum';
import { MapWithDefault } from '@app-shared/functions/helpers.functions';
import { Locale as DateFnLocale } from 'date-fns';
import english from '@angular/common/locales/en-GB';
import french from '@angular/common/locales/fr';
import german from '@angular/common/locales/de';
import swiss from '@angular/common/locales/de-CH';
import italian from '@angular/common/locales/it';
import spanish from '@angular/common/locales/es';
import czech from '@angular/common/locales/cs';
import belgianDutch from '@angular/common/locales/nl-BE';

export function registerLocales(): void {
  registerLocaleData(english);
  registerLocaleData(french);
  registerLocaleData(german);
  registerLocaleData(swiss);
  registerLocaleData(italian);
  registerLocaleData(spanish);
  registerLocaleData(czech);
  registerLocaleData(belgianDutch);
}

export const dateFnLocaleMap = new MapWithDefault<LanguageCodes, DateFnLocale>(
  enGB,
);
dateFnLocaleMap.set(LanguageCode.EN_GB, enGB);
dateFnLocaleMap.set(LanguageCode.DE_DE, de);
dateFnLocaleMap.set(LanguageCode.DE_CH, de);
dateFnLocaleMap.set(LanguageCode.FR_FR, fr);
dateFnLocaleMap.set(LanguageCode.IT_IT, it);
dateFnLocaleMap.set(LanguageCode.CS_CZ, cs);
dateFnLocaleMap.set(LanguageCode.ES_ES, es);
dateFnLocaleMap.set(LanguageCode.NL_BE, nlBE);
